export default class PairingCodeService {
	constructor(apiService) {
		this.apiService = apiService
	}

	createEntity(params) {
		return this.apiService.callPost('me/pairing_codes', params)
	}

	deletePairingCode(id) {
		return this.apiService.callDelete('me/pairing_codes/' + id)
	}
}



// WEBPACK FOOTER //
// ./src/service/PairingCodeService.js